import { SetupService } from './setup.service';

export const services = [
  SetupService,
];
